"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});

var _jssPreset = _interopRequireDefault(require("./jssPreset"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/jssPreset/index.js
// module id = 79
// module chunks = 0